import React, { useEffect, useState } from 'react';
import db from '../firebase';
import { collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import './ManageInterns.css';

function ManageInterns() {
  const [interns, setInterns] = useState([]);
  const [status, setStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    joiningDate: '',
    endingDate: '',
    domain: '',
    responsibilities: '',
    projects: ''
  });

  const fetchInterns = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'Interns'));
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setInterns(data);
    } catch (error) {
      console.error('Error fetching interns:', error);
    }
  };

  useEffect(() => {
    fetchInterns();
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newIntern = {
      ...formData,
      responsibilities: formData.responsibilities.split(',').map(s => s.trim()),
      projects: formData.projects.split(',').map(s => s.trim())
    };

    try {
      await addDoc(collection(db, 'Interns'), newIntern);
      setStatus('✅ Intern added successfully.');
      setFormData({
        name: '',
        joiningDate: '',
        endingDate: '',
        domain: '',
        responsibilities: '',
        projects: ''
      });
      fetchInterns(); // refresh list
    } catch (error) {
      console.error('Error adding intern:', error);
      setStatus('❌ Failed to add intern.');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this intern?")) return;

    try {
      await deleteDoc(doc(db, 'Interns', id));
      setStatus('✅ Intern deleted.');
      setInterns(prev => prev.filter(i => i.id !== id));
    } catch (error) {
      console.error('Error deleting intern:', error);
      setStatus('❌ Failed to delete.');
    }
  };

  return (
    <div className="manage-interns-container">
      <h2>Manage Interns</h2>
      {status && <p className="status">{status}</p>}

      <form className="intern-form" onSubmit={handleSubmit}>
        <input type="text" name="name" placeholder="Intern Name" value={formData.name} onChange={handleChange} required />
        <input type="date" name="joiningDate" placeholder="Joining Date" value={formData.joiningDate} onChange={handleChange} required />
        <input type="date" name="endingDate" placeholder="Ending Date" value={formData.endingDate} onChange={handleChange} required />
        <input type="text" name="domain" placeholder="Domain" value={formData.domain} onChange={handleChange} required />
        <input type="text" name="responsibilities" placeholder="Responsibilities (comma-separated)" value={formData.responsibilities} onChange={handleChange} required />
        <input type="text" name="projects" placeholder="Projects (comma-separated)" value={formData.projects} onChange={handleChange} required />
        <button type="submit">Add Intern</button>
      </form>

      <div className="intern-table">
        <div className="table-header">
          <span>Name</span>
          <span>Joining</span>
          <span>Ending</span>
          <span>Domain</span>
          <span>Responsibilities</span>
          <span>Projects</span>
          <span>Action</span>
        </div>
        {interns.map((intern) => (
          <div className="table-row" key={intern.id}>
            <span>{intern.name}</span>
            <span>{intern.joiningDate}</span>
            <span>{intern.endingDate}</span>
            <span>{intern.domain}</span>
            <span>{Array.isArray(intern.responsibilities) ? intern.responsibilities.join(', ') : intern.responsibilities}</span>
            <span>{Array.isArray(intern.projects) ? intern.projects.join(', ') : intern.projects}</span>
            <span><button className="delete-btn" onClick={() => handleDelete(intern.id)}>Delete</button></span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ManageInterns;
